<template>
    <div class="main-content d-flex ">
        <img src="@/assets/illustrations/404Page-illustration.svg">
        <div class="content ">
            <div class="content-info">
                <div class="fs f-bold mb-05">Whooops!</div>
                Sorry, the page you are looking for doesn't exist
            </div>
            <div class="btn-group">
                <el-button class="btn" type="primary" round @click="GoHomePage" >Go Home</el-button>
                <el-button class="btn-back" type="text" @click="GoBack" >Go back</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Error',
  methods: {
    GoHomePage() {
      this.$router.push('/');
    },
    GoBack() {
      this.$router.go(-1);
    },

  }
};
</script>

<style lang="scss" scoped>
.main-content {
    // minus footer and header
    height: calc(100vh - 7em - 80px);
    align-content: center;
    align-items: center;
    justify-content: center;

    img {
        width: 70%;
        object-fit: contain;
    }

    .content{
        width:30%;
        font-size: 1.5rem;
        margin-right: 6rem;
        margin-bottom: 15rem;
        flex-direction: column;
        align-items: space-around;
        .fs{
            color:#EF6563;
            font-size: 4rem;
        }
        .btn{
            margin-top: 3rem;
            margin-right: 0;
        }
    }
    @media only screen and (max-width: $md) {
        display:flex;
        flex-direction: column-reverse;
        .content{
            width: 100%;
            margin: 3rem 0rem 1rem 5rem;
            font-size: 1.2rem;
            text-align: center;
            .fs{
                display: flex;
                justify-content: center;
                font-size: 3rem;
            }
        }

        img {
            width: 100%;
        }
    }
    @media only screen and (max-width: $sm) {

        .content{
            //width: 100%;
            margin: 3rem 0rem 1rem 1rem;
            font-size: 1rem;
            .fs{
                font-size: 2rem;
            }
            .btn-group{
                flex-basis: 20%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .btn-back{
                    margin-right:0.75rem;
                }

            }

        }
        img {
            width: 100%;
        }
    }
}
</style>
